"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageWorkspaceRequestModes = void 0;
var ManageWorkspaceRequestModes;
(function (ManageWorkspaceRequestModes) {
    ManageWorkspaceRequestModes["PRIVILEGES"] = "privileges";
    ManageWorkspaceRequestModes["DELETE_MEMBER"] = "delete-member";
    ManageWorkspaceRequestModes["UPDATE_MEMBER"] = "update-member";
    ManageWorkspaceRequestModes["INVITE_MEMBERS"] = "invite-members";
    ManageWorkspaceRequestModes["EXIT_WORKSPACE"] = "exit-workspace";
    ManageWorkspaceRequestModes["CHANGE_DEFAULT"] = "default-workspace";
    ManageWorkspaceRequestModes["SWITCH_WORKSPACE"] = "switch-workspace";
    ManageWorkspaceRequestModes["REPORT_SUBSCRIPTION"] = "report-subscription";
})(ManageWorkspaceRequestModes = exports.ManageWorkspaceRequestModes || (exports.ManageWorkspaceRequestModes = {}));
